module.exports = __webpack_public_path__ + "static/media/Youtube.088c3d78.svg";